@switch (spoersmaal().type) {
  @case (spoersmaalstyper.grupperingstittel) {
    <h2 class="grupperingstittel">{{ spoersmaal().tittel }}</h2>
  }
  @case (spoersmaalstyper.fritekst) {
    <div class="fritekst">
      <div class="friteksttittel" >
        <ng-container *ngTemplateOutlet="besvartIndikatorFragment"/>
        <div>{{ spoersmaal().tittel }}</div>
      </div>
      <mat-form-field>
        <riktekst-redigering [skjemakontroll]="spoersmaalsvarKontrollForHtmlTekst()" [skjulMenylinje]="true" />
      </mat-form-field>
    </div>
  }
  @case (spoersmaalstyper.boolsk) {
    <div class="boolsk">
      <ng-container *ngTemplateOutlet="besvartIndikatorFragment"/>
      <mat-checkbox [formControl]="skjemakontroll().controls.svar">{{ spoersmaal().tittel }}</mat-checkbox>
    </div>
  }
  @case (spoersmaalstyper.rangering) {
    <div class="rangering">
      <div class="tittel">
        <ng-container *ngTemplateOutlet="besvartIndikatorFragment"/>
        <mat-label [id]="spoersmaal().id">{{ spoersmaal().tittel }}</mat-label>
      </div>

      <mat-radio-group [formControl]="skjemakontroll().controls.svar"
                       [style.grid-template-columns]="'repeat(' + spoersmaal().oppsett.rangering!.alternativer.length + ', 1fr)'"
                       [attr.aria-labelledby]="spoersmaal().id">
        @for (alternativ of spoersmaal().oppsett.rangering!.alternativer; track $index) {
          <mat-radio-button [value]="alternativ.verdi"
                            [labelPosition]="radioknappTittelplassering()"
                            matTooltip="{{ alternativ.tittel }}"
                            matTooltipPosition="above"
                            matTooltipShowDelay="1000"
                            matTooltipClass="spørreundersøkelse-spørsmål-skjema-rangering-tooltip"
                            aria-label="{{ alternativ.tittel }}">
            @if (visValgtittel()) {
              {{ alternativ.tittel }}
            }
          </mat-radio-button>
        }
      </mat-radio-group>

    </div>
  }
  @case (spoersmaalstyper.velgEnAvFlere) {
    <div class="velgEnAvFlere">
      <ng-container *ngTemplateOutlet="besvartIndikatorFragment"/>
      <mat-form-field>
        <mat-label>{{ spoersmaal().tittel }}</mat-label>
        <mat-select [formControl]="skjemakontroll().controls.svar">
          @for (alternativ of spoersmaal().oppsett.velgEnAvFlere!.alternativer; track $index) {
            <mat-option [value]="alternativ.verdi">{{ alternativ.tittel }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @case (spoersmaalstyper.velgNoenAvFlere) {
    <div class="velgNoenAvFlere">
      <div class="tittel">
        <ng-container *ngTemplateOutlet="besvartIndikatorFragment"/>
        <div>
          <mat-label [id]="spoersmaal().id">{{ spoersmaal().tittel }}</mat-label>
          @if (maksimaltAntallValg(); as maks) {
            <div class="maksimalt-antall-valg">{{ 'Velg inntil {antall}' | translate: {antall: maks} }}</div>
          }
        </div>
      </div>
      <div class="alternativer" role="group" [attr.aria-labelledby]="spoersmaal().id">
        @for (alternativ of spoersmaal().oppsett.velgNoenAvFlere!.alternativer; track alternativ.verdi) {
          <mat-checkbox [checked]="erValgt(alternativ.verdi)"
                        [disabled]="kanIkkeVelges(alternativ.verdi)"
                        (change)="velg(alternativ.verdi, $event.checked)">{{ alternativ.tittel }}</mat-checkbox>
        }
      </div>
    </div>
  }
}


<ng-template #besvartIndikatorFragment>
  <div class="besvart-indikator">
    @if (erBesvart()) {
      <mat-icon @fadeInn>check</mat-icon>
    }
  </div>
</ng-template>


<!--
<div>type:{{spoersmaal().type}}</div>
<div>svar:{{skjemakontroll().value.svar}}</div>
-->
